module.exports = __webpack_public_path__ + "img/DW_zlbh.6b215fde.jpg";